type GraphQLResponse = {
  data?: unknown;
  errors?: Array<{ message: string; [key: string]: unknown }>;
};

export class GraphQLClientError extends Error {
  response: GraphQLResponse;

  constructor(response: GraphQLResponse) {
    const message = response.errors?.at(0)?.message ?? "Unknown GraphQL error";
    super(message);
    this.name = "GraphQLClientError";
    this.response = response;
  }
}
